import { Component, EventEmitter, Input, Output } from '@angular/core';
import { APP_CONFIG } from '../../environment';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { COUNTRY_SETTINGS } from '../../providers/myria/app-variables';
import { WALLET_SERVICES } from '../../model/types/wallet';
import { RouteProvider } from '../../providers/route/route';
import { TranslateService } from '@ngx-translate/core';
import { CommonProvider } from '../../providers/common/common';
import { DisabledServiceSetting } from '../../model/models/wallet/wallet';
import { WalletProvider } from '../../providers/wallet/wallet';
@Component({
  selector: 'rmt-wallet-services',
  templateUrl: 'rmt-wallet-services.html'
})
export class RmtWalletServicesComponent {
  services:any;
  servicesMaster: any;
  serviceSettingsMap: DisabledServiceSetting[] = [];
  showServiceDisabledAlert: boolean = false;
  showBillPayDisabledAlert: boolean = false;
  showP2PDisabledAlert: boolean = false;
  showAirTimeDisabledAlert: boolean = false;
  @Input() isLoading:boolean = true;
  @Output() onServiceClickEmitter: EventEmitter<any> = new EventEmitter();

  serviceDisabledErrorMessage: string = this.translate.instant('page.ewalletpage.receptionDisabledErrorMessage');
  serviceDisabledAlertHeader: string = this.translate.instant('page.ewalletpage.receptionDisabled.Header');
  serviceDisabledAlertBody: string = this.translate.instant('page.ewalletpage.receptionDisabled.Body');

  constructor(
    private utilsProvider: UtilsProvider,
    private routeProvider: RouteProvider,
    private translate: TranslateService,
    private commonProvider: CommonProvider,
    private walletProvider: WalletProvider
  ) {
  }

  async ngOnInit() {
    this.servicesMaster = APP_CONFIG.region.walletServices;
    this.servicesMaster.sort((a, b) => a.sortOrder - b.sortOrder);
    let isAirTimeEnabled: any = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.EENABLE_MOBILE_TOP_UP);
    isAirTimeEnabled = (isAirTimeEnabled == 1) ? true : false;
    if (this.commonProvider.isSN() || this.walletProvider.isEFTWalletDown) this.loadServiceDisableSettings(this.walletProvider.isEFTWalletDown);
  }

  onServiceClick(service) {
    if (service) {
      const serviceDisabled =
        (service.type === WALLET_SERVICES.RECEIVE && this.showServiceDisabledAlert) ||
        (service.type === WALLET_SERVICES.RECEIVE && this.walletProvider.isEFTWalletDown) ||
        (service.type === WALLET_SERVICES.BILLPAYMENTS && this.walletProvider.isEFTWalletDown) ||
        (service.type === WALLET_SERVICES.AIRTIME && this.walletProvider.isEFTWalletDown) ||
        (service.type === WALLET_SERVICES.CARD && this.walletProvider.isEFTWalletDown) ||
        (service.type === WALLET_SERVICES.SEND && this.walletProvider.isEFTWalletDown && !this.commonProvider.isSN()) ||
        (service.type === WALLET_SERVICES.BILLPAYMENTS && this.showBillPayDisabledAlert) || (service.type === WALLET_SERVICES.AIRTIME && this.showAirTimeDisabledAlert);

        service.type === WALLET_SERVICES.SEND && this.showP2PDisabledAlert ? service.p2pDisabled = true : service.p2pDisabled = false;

      if (serviceDisabled) {
        this.onServiceDisabled(service);
        return;
      }
    }

    if(this.onServiceClickEmitter){
      this.onServiceClickEmitter.emit(service);
    }
  }

  findServiceConfig(service) {
    return this.serviceSettingsMap.find(s => s.type === service.type);
  }

  onServiceDisabled(service) {
    let title: string, body: string;
    if(this.walletProvider.isEFTWalletDown){
      title = this.translate.instant('page.eWalletPage.eftDownModal.Header');
      body = this.translate.instant('page.eWalletPage.eftDownModal.Body');
    } else {
      const config = this.findServiceConfig(service);
      title = config
        ? this.translate.instant(config.headerKey)
        : this.translate.instant('alerts.genericDisabledTitle');
  
      body = config
        ? this.translate.instant(config.bodyKey)
        : this.translate.instant('alerts.genericDisabledBody');
    }

    if(this.walletProvider.isEFTWalletDown){

    }
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title,
        subtitleInnerHtml: body ? body.replace(/\\n/g, '<br>') : '',
        primaryButtonText: this.translate.instant('global.gotItButton'),
        showFullPage: false,
        isModal: true,
        hideHeader: true,
        showSecondaryButton: false,
      }
    );
  }

  getDynamicClass(service) {
    if(this.walletProvider.isEFTWalletDown){
      if (!service || (service.type === WALLET_SERVICES.SEND && this.commonProvider.isSN()) || (service && service.type === WALLET_SERVICES.MORE)) return;
      return 'is-disabled';
    } else {
      if (!service || service.type === WALLET_SERVICES.SEND) return;
  
      const config = this.findServiceConfig(service);
      if (config && this[config.property]) {
        return 'is-disabled';
      }
    }
  }

  getDisabledServices() {
    return this.serviceSettingsMap.filter(cfg => this[cfg.property]);
  }


  async loadServiceDisableSettings(isEFTWalletDown: boolean = false) {

    this.serviceSettingsMap = [
      {
        type: WALLET_SERVICES.RECEIVE,
        flag: COUNTRY_SETTINGS.DISABLE_INWARD_REMMITANCE,
        property: 'showServiceDisabledAlert',
        messageKey: 'page.ewalletpage.receptionDisabledErrorMessage',
        headerKey:  'page.ewalletpage.receptionDisabled.Header',
        bodyKey:    'page.ewalletpage.receptionDisabled.Body'
      },
      {
        type: WALLET_SERVICES.BILLPAYMENTS,
        flag: COUNTRY_SETTINGS.DISABLE_BILL_PAY,
        property: 'showBillPayDisabledAlert',
        messageKey: 'page.ewalletpage.BillpayDisabledErrorMessage',
        headerKey:  'page.ewalletpage.BillpayDisabled.Header',
        bodyKey:    'page.ewalletpage.BillpayDisabled.Body'
      },
      {
        type: WALLET_SERVICES.SEND,
        flag: COUNTRY_SETTINGS.DISABLE_P2P,
        property: 'showP2PDisabledAlert',
        messageKey: 'page.ewalletpage.sendDisabledErrorMessage',
        headerKey:  'page.ewalletpage.sendDomesticDisabled.Header',
        bodyKey:    'page.ewalletpage.sendDomesticDisabled.Body'
      },
      {
        type: WALLET_SERVICES.AIRTIME,
        flag: COUNTRY_SETTINGS.EENABLE_MOBILE_TOP_UP,
        property: 'showAirTimeDisabledAlert',
        messageKey: 'page.ewalletpage.topupDisabledErrorMessage',
        headerKey:  'page.ewalletpage.topupDisabled.Header',
        bodyKey:    'page.ewalletpage.topupDisabled.Body'
      }
    ];

    if(isEFTWalletDown){
      this.serviceSettingsMap.forEach((item) => {
        this[item.property] = true;
      })
    } else {
      const promises = this.serviceSettingsMap.map(({ flag }) =>
        this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, flag)
      );
  
      const results = await Promise.all(promises);
  
      this.serviceSettingsMap.forEach(({ property }, index) => {
        this[property] = results[index] != 1;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-services/rmt-wallet-services.ts